export function AirPlan() {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0416 29.4202L15.1483 26.8068C15.6149 26.4068 16.3883 26.4068 16.8549 26.8068L19.9616 29.4202C20.6816 29.7802 21.5616 29.4202 21.8283 28.6468L22.4149 26.8735C22.5616 26.4468 22.4149 25.8202 22.0949 25.5002L19.0683 22.4602C18.8416 22.2468 18.6683 21.8202 18.6683 21.5135V17.7135C18.6683 17.1535 19.0816 16.8868 19.6016 17.1002L26.1483 19.9268C27.1749 20.3668 28.0149 19.8202 28.0149 18.7002V16.9802C28.0149 16.0868 27.3483 15.0602 26.5216 14.7135L19.0683 11.5002C18.8549 11.4068 18.6683 11.1268 18.6683 10.8868V6.88684C18.6683 5.63351 17.7483 4.15351 16.6283 3.58018C16.2283 3.38018 15.7616 3.38018 15.3616 3.58018C14.2416 4.15351 13.3216 5.64684 13.3216 6.90018V10.9002C13.3216 11.1402 13.1349 11.4202 12.9216 11.5135L5.48161 14.7268C4.65495 15.0602 3.98828 16.0868 3.98828 16.9802V18.7002C3.98828 19.8202 4.82828 20.3668 5.85495 19.9268L12.4016 17.1002C12.9083 16.8735 13.3349 17.1535 13.3349 17.7135V21.5135C13.3349 21.8202 13.1616 22.2468 12.9483 22.4602L9.92161 25.5002C9.60161 25.8202 9.45495 26.4335 9.60161 26.8735L10.1883 28.6468C10.4283 29.4202 11.3083 29.7935 12.0416 29.4202Z"
        stroke="#1E85FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function AirPlanPath() {
  return (
    <svg
      width="132"
      height="7"
      viewBox="0 0 132 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333333 3.5C0.333333 4.97276 1.52724 6.16667 3 6.16667C4.47276 6.16667 5.66667 4.97276 5.66667 3.5C5.66667 2.02724 4.47276 0.833333 3 0.833333C1.52724 0.833333 0.333333 2.02724 0.333333 3.5ZM126.333 3.5C126.333 4.97276 127.527 6.16667 129 6.16667C130.473 6.16667 131.667 4.97276 131.667 3.5C131.667 2.02724 130.473 0.833333 129 0.833333C127.527 0.833333 126.333 2.02724 126.333 3.5ZM3 4H4.01613V3H3V4ZM6.04839 4H8.08065V3H6.04839V4ZM10.1129 4H12.1452V3H10.1129V4ZM14.1774 4H16.2097V3H14.1774V4ZM18.2419 4H20.2742V3H18.2419V4ZM22.3065 4H24.3387V3H22.3065V4ZM26.371 4H28.4032V3H26.371V4ZM30.4355 4H32.4677V3H30.4355V4ZM34.5 4H36.5322V3H34.5V4ZM38.5645 4H40.5968V3H38.5645V4ZM42.629 4H44.6613V3H42.629V4ZM46.6935 4H48.7258V3H46.6935V4ZM50.7581 4H52.7903V3H50.7581V4ZM54.8226 4H56.8548V3H54.8226V4ZM58.8871 4H60.9193V3H58.8871V4ZM62.9516 4H64.9839V3H62.9516V4ZM67.0161 4H69.0484V3H67.0161V4ZM71.0806 4H73.1129V3H71.0806V4ZM75.1451 4H77.1774V3H75.1451V4ZM79.2096 4H81.2419V3H79.2096V4ZM83.2742 4H85.3064V3H83.2742V4ZM87.3387 4H89.3709V3H87.3387V4ZM91.4032 4H93.4354V3H91.4032V4ZM95.4677 4H97.5V3H95.4677V4ZM99.5322 4H101.564V3H99.5322V4ZM103.597 4H105.629V3H103.597V4ZM107.661 4H109.694V3H107.661V4ZM111.726 4H113.758V3H111.726V4ZM115.79 4H117.823V3H115.79V4ZM119.855 4H121.887V3H119.855V4ZM123.919 4H125.952V3H123.919V4ZM127.984 4H129V3H127.984V4Z"
        fill="#1E85FF"
      />
    </svg>
  );
}

export function ArrowDown(props) {
  return (
    <svg
      className={props?.className ? props.className : ""}
      fill={props?.fill ? props.fill : "#000000"}
      enable-background="new 0 0 128 128"
      height={props?.height ? props.height : 18}
      viewBox="0 0 128 128"
      width={props?.width ? props.width : 18}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Down_Arrow_3_"
        d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
      ></path>
    </svg>
  );
}

export function ArrowRightIcon(props) {
  return (
    <svg
      className={props?.className ? props.className : ""}
      width={props?.width ? props.width : "24"}
      height={props?.height ? props.height : "25"}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4297 6.42969L20.4997 12.4997L14.4297 18.5697"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12.5H20.33"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Buildings() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 22H5C3 22 2 21 2 19V11C2 9 3 8 5 8H10V19C10 21 11 22 13 22Z"
        stroke="#1E85FF"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.11 4C10.03 4.3 10 4.63 10 5V8H5V6C5 4.9 5.9 4 7 4H10.11Z"
        stroke="#1E85FF"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 8V13"
        stroke="#1E85FF"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 8V13"
        stroke="#1E85FF"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 17H15C14.45 17 14 17.45 14 18V22H18V18C18 17.45 17.55 17 17 17Z"
        stroke="#1E85FF"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 13V17"
        stroke="#1E85FF"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 19V5C10 3 11 2 13 2H19C21 2 22 3 22 5V19C22 21 21 22 19 22H13C11 22 10 21 10 19Z"
        stroke="#1E85FF"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CalendarIcon(props) {
  return (
    <svg
      width={props?.width ? props.width : "21"}
      height={props?.height ? props.height : "20"}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33398 1.66602V4.16602"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 1.66602V4.16602"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.58398 7.57422H17.7507"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.167 7.08268V14.166C18.167 16.666 16.917 18.3327 14.0003 18.3327H7.33366C4.41699 18.3327 3.16699 16.666 3.16699 14.166V7.08268C3.16699 4.58268 4.41699 2.91602 7.33366 2.91602H14.0003C16.917 2.91602 18.167 4.58268 18.167 7.08268Z"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6631 11.4167H10.6706"
        stroke="#00B7AC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.57908 11.4167H7.58657"
        stroke="#00B7AC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.57908 13.9167H7.58657"
        stroke="#00B7AC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckMark() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM14.78 7.7L9.11 13.37C8.97 13.51 8.78 13.59 8.58 13.59C8.38 13.59 8.19 13.51 8.05 13.37L5.22 10.54C4.93 10.25 4.93 9.77 5.22 9.48C5.51 9.19 5.99 9.19 6.28 9.48L8.58 11.78L13.72 6.64C14.01 6.35 14.49 6.35 14.78 6.64C15.07 6.93 15.07 7.4 14.78 7.7Z"
        fill="#1E85FF"
      />
    </svg>
  );
}

export function ChevronDown() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.668 6L8.66797 10L4.66797 6"
        stroke="#050001"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      width="24"
      height="32"
      viewBox="0 0 24 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 24L20 8M20 24L4 8"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function FacebookIcon(props) {
  return (
    <svg
      width={props?.width ? props.width : "31"}
      height={props?.height ? props.height : "30"}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15.5" cy="15" r="15" fill="#006699" />
      <path
        d="M16.9624 11.2874H18.5V9H16.6812C14.4876 9.0938 14.0376 10.3312 14 11.625V12.7688H12.5V15H14V21H16.25V15H18.1062L18.4624 12.7688H16.25V12.075C16.244 11.9763 16.2577 11.8773 16.2904 11.784C16.3231 11.6906 16.3742 11.6047 16.4405 11.5314C16.5069 11.458 16.5872 11.3986 16.6769 11.3567C16.7665 11.3148 16.8636 11.2913 16.9624 11.2874Z"
        fill="#FEFEFF"
      />
    </svg>
  );
}

export function Gallery() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.67188 18.9501L7.60187 15.6401C8.39187 15.1101 9.53187 15.1701 10.2419 15.7801L10.5719 16.0701C11.3519 16.7401 12.6119 16.7401 13.3919 16.0701L17.5519 12.5001C18.3319 11.8301 19.5919 11.8301 20.3719 12.5001L22.0019 13.9001"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function GalleryRemove() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#EA5455" />
      <path
        d="M6 14L14 6M14 14L6 6"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function HotelIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_25022_102488"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path
          d="M23.25 23.25V0.75H0.75V23.25H23.25Z"
          fill="white"
          stroke="white"
          stroke-width="1.5"
        />
      </mask>
      <g mask="url(#mask0_25022_102488)">
        <path
          d="M4.46875 23.2969H19.5313V4.46873H4.46875V23.2969Z"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5352 2.21035C19.5352 1.81084 19.3766 1.42787 19.0939 1.14545C18.8114 0.862648 18.4285 0.704117 18.0289 0.704117H5.97894C5.57938 0.704117 5.19641 0.862648 4.91398 1.14545C4.63123 1.42787 4.47266 1.81084 4.47266 2.21035V4.46973H19.5352V2.21035Z"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.4922 23.2969H13.5048V18.7781H10.4922V23.2969Z"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.48047 7.4803V8.2334"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.4961 7.4803V8.2334"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5039 7.4803V8.2334"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5195 7.4803V8.2334"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.48047 11.2469V12"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.4961 11.2469V12"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5039 11.2469V12"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5195 11.2469V12"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.48047 15.0135V15.7666"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.4961 15.0135V15.7666"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5039 15.0135V15.7666"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5195 15.0135V15.7666"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.48047 18.7786V19.5317"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5195 18.7786V19.5317"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.703125 23.2969H23.2969"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
}

export function LangIcon(props) {
  return (
    <svg
      className={props?.className ? props.className : ""}
      fill={props?.fill ? props.fill : "#000000"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={props?.width ? props.width : 20}
      height={props?.height ? props.height : 20}
    >
      <g id="Layer_2" data-name="Layer 2">
        <path d="M87.95636,73.23224a44.29242,44.29242,0,0,0,6.54358-23.23145L94.5,50l-.00006-.00079a44.2927,44.2927,0,0,0-6.54376-23.23169l-.02442-.03815a44.5022,44.5022,0,0,0-75.8634-.00031l-.02472.03864a44.51347,44.51347,0,0,0-.00018,46.46436l.02514.03918a44.50213,44.50213,0,0,0,75.86292-.00037Zm-32.26825,13.641a10.81448,10.81448,0,0,1-2.8894,1.99561,6.52134,6.52134,0,0,1-5.59748,0,13.62135,13.62135,0,0,1-5.04809-4.44233,39.77474,39.77474,0,0,1-5.74762-12.47064Q43.19588,71.538,50,71.53021q6.80127,0,13.59521.42572a50.19826,50.19826,0,0,1-2.438,6.71222A25.80323,25.80323,0,0,1,55.68811,86.87329ZM10.587,52.5H28.536a88.30459,88.30459,0,0,0,1.62274,14.91418q-7.35983.64766-14.68207,1.779A39.23059,39.23059,0,0,1,10.587,52.5Zm4.88964-21.69324Q22.796,31.941,30.16388,32.58618A88.15014,88.15014,0,0,0,28.5376,47.5H10.587A39.2306,39.2306,0,0,1,15.47662,30.80676ZM44.31183,13.12665a10.81146,10.81146,0,0,1,2.8894-1.99561,6.52134,6.52134,0,0,1,5.59748,0,13.62131,13.62131,0,0,1,5.04809,4.44232A39.77482,39.77482,0,0,1,63.59436,28.044Q56.804,28.46185,50,28.46973q-6.80127-.00009-13.59528-.42578a50.18985,50.18985,0,0,1,2.43805-6.71216A25.80254,25.80254,0,0,1,44.31183,13.12665ZM89.413,47.5H71.464a88.31173,88.31173,0,0,0-1.62274-14.91425q7.35992-.64764,14.68207-1.779A39.2306,39.2306,0,0,1,89.413,47.5ZM35.18756,67.02545A82.69645,82.69645,0,0,1,33.53729,52.5H66.4632a82.67828,82.67828,0,0,1-1.64728,14.52563Q57.41607,66.54,50,66.53027,42.58927,66.53018,35.18756,67.02545Zm29.62482-34.051A82.70224,82.70224,0,0,1,66.46259,47.5H33.53674A82.67914,82.67914,0,0,1,35.184,32.97424q7.39985.4855,14.816.49543Q57.41074,33.46967,64.81238,32.97449ZM71.46228,52.5H89.413a39.23052,39.23052,0,0,1-4.88971,16.69318q-7.31936-1.13435-14.68719-1.77942A88.14559,88.14559,0,0,0,71.46228,52.5ZM81.52539,26.20477q-6.39945.92331-12.83734,1.462a57.01792,57.01792,0,0,0-2.9754-8.39581,35.48007,35.48007,0,0,0-4.13984-7.04529A39.49152,39.49152,0,0,1,81.52539,26.20477ZM22.06915,22.06915a39.48682,39.48682,0,0,1,16.3559-9.84289c-.09369.12134-.19006.2373-.28241.36114A45.64338,45.64338,0,0,0,31.321,27.66754q-6.43816-.54528-12.84643-1.46277A39.82535,39.82535,0,0,1,22.06915,22.06915Zm-3.5946,51.726q6.39943-.9234,12.83728-1.462A57.01789,57.01789,0,0,0,34.28729,80.729a35.48425,35.48425,0,0,0,4.13983,7.04529A39.49154,39.49154,0,0,1,18.47455,73.79517Zm59.45624,4.13562a39.48587,39.48587,0,0,1-16.3559,9.84289c.09369-.12134.19-.2373.28241-.36114A45.64338,45.64338,0,0,0,68.679,72.3324q6.43816.54528,12.84643,1.46277A39.82535,39.82535,0,0,1,77.93079,77.93079Z"></path>
      </g>
    </svg>
  );
}

export function LinkedinIcon(props) {
  return (
    <svg
      width={props?.width ? props.width : "31"}
      height={props?.height ? props.height : "30"}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15.5" cy="15" r="15" fill="#1AB3FF" />
      <path d="M9.72852 12.7939H12.3108V20.6H9.72852V12.7939Z" fill="#FEFEFF" />
      <path
        d="M18.9749 12.5352C17.8427 12.5352 17.1674 12.9523 16.4524 13.8659V12.7934H13.8701V20.5995H16.4721V16.3687C16.4721 15.4748 16.9289 14.6009 17.9617 14.6009C18.9946 14.6009 19.6103 15.4748 19.6103 16.3488V20.5995H22.2124V16.1702C22.2124 13.0913 20.1268 12.5352 18.9749 12.5352Z"
        fill="#FEFEFF"
      />
      <path
        d="M11.0295 9C10.1754 9 9.5 9.61569 9.5 10.3706C9.5 11.1255 10.1754 11.7412 11.0295 11.7412C11.8835 11.7412 12.559 11.1255 12.559 10.3706C12.559 9.61569 11.8835 9 11.0295 9Z"
        fill="#FEFEFF"
      />
    </svg>
  );
}

export function LocationMarkerIcon(props) {
  return (
    <svg
      className={props?.className ? props.className : ""}
      width={props?.width ? props.width : "31"}
      height={props?.height ? props.height : "30"}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0001 19.0255C19.4412 19.0255 21.4201 17.0466 21.4201 14.6055C21.4201 12.1644 19.4412 10.1855 17.0001 10.1855C14.559 10.1855 12.5801 12.1644 12.5801 14.6055C12.5801 17.0466 14.559 19.0255 17.0001 19.0255Z"
        stroke="#00B7AC"
        strokeWidth="1.5"
      />
      <path
        d="M5.12808 12.0282C7.91892 -0.240179 26.0948 -0.226012 28.8714 12.0423C30.5006 19.239 26.0239 25.3307 22.0998 29.099C19.2523 31.8473 14.7473 31.8473 11.8856 29.099C7.97558 25.3307 3.49892 19.2248 5.12808 12.0282Z"
        stroke="#00B7AC"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function MapPin() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 10.5C15 11.2956 14.6839 12.0587 14.1213 12.6213C13.5587 13.1839 12.7956 13.5 12 13.5C11.2044 13.5 10.4413 13.1839 9.87868 12.6213C9.31607 12.0587 9 11.2956 9 10.5C9 9.70435 9.31607 8.94129 9.87868 8.37868C10.4413 7.81607 11.2044 7.5 12 7.5C12.7956 7.5 13.5587 7.81607 14.1213 8.37868C14.6839 8.94129 15 9.70435 15 10.5Z"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5 10.5C19.5 17.642 12 21.75 12 21.75C12 21.75 4.5 17.642 4.5 10.5C4.5 8.51088 5.29018 6.60322 6.6967 5.1967C8.10322 3.79018 10.0109 3 12 3C13.9891 3 15.8968 3.79018 17.3033 5.1967C18.7098 6.60322 19.5 8.51088 19.5 10.5Z"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function MenuIcon(props) {
  return (
    <svg
      className={props?.className ? props.className : ""}
      width={props?.width ? props.width : "24"}
      height={props?.height ? props.height : "25"}
      viewBox="0 0 24 25"
      fill={props?.fill ? props?.fill : "#000000"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7.5H21"
        stroke="#050001"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 12.5H21"
        stroke="#050001"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 17.5H21"
        stroke="#050001"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Moon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.02384 12.3003C3.3398 16.6766 7.1752 20.2372 11.7654 20.4327C15.004 20.5686 17.9003 19.107 19.638 16.8041C20.3577 15.8608 19.9716 15.232 18.7692 15.4444C18.1811 15.5464 17.5755 15.5889 16.9436 15.5634C12.6518 15.3935 9.14117 11.9179 9.12361 7.8134C9.11484 6.70869 9.35181 5.66345 9.78186 4.7117C10.2558 3.65797 9.68532 3.1566 8.58824 3.60698C5.11268 5.02612 2.73421 8.41675 3.02384 12.3003Z"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function Note() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 8.25V18C20 21 18.21 22 16 22H8C5.79 22 4 21 4 18V8.25C4 5 5.79 4.25 8 4.25C8 4.87 8.24997 5.43 8.65997 5.84C9.06997 6.25 9.63 6.5 10.25 6.5H13.75C14.99 6.5 16 5.49 16 4.25C18.21 4.25 20 5 20 8.25Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 4.25C16 5.49 14.99 6.5 13.75 6.5H10.25C9.63 6.5 9.06997 6.25 8.65997 5.84C8.24997 5.43 8 4.87 8 4.25C8 3.01 9.01 2 10.25 2H13.75C14.37 2 14.93 2.25 15.34 2.66C15.75 3.07 16 3.63 16 4.25Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 13H12"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 17H16"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function PackageTypeIcon(props) {
  return (
    <svg
      className={props?.className ? props.className : ""}
      width="35"
      height="34"
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9163 31.1673H7.58301C4.74967 31.1673 3.33301 29.7507 3.33301 26.9173V15.584C3.33301 12.7507 4.74967 11.334 7.58301 11.334H14.6663V26.9173C14.6663 29.7507 16.083 31.1673 18.9163 31.1673Z"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8222 5.66602C14.7088 6.09102 14.6663 6.55852 14.6663 7.08268V11.3327H7.58301V8.49935C7.58301 6.94102 8.85801 5.66602 10.4163 5.66602H14.8222Z"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.333 11.334V18.4173"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 11.334V18.4173"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.583 24.084H21.7497C20.9705 24.084 20.333 24.7215 20.333 25.5007V31.1673H25.9997V25.5007C25.9997 24.7215 25.3622 24.084 24.583 24.084Z"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 18.416V24.0827"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.667 26.9173V7.08398C14.667 4.25065 16.0837 2.83398 18.917 2.83398H27.417C30.2503 2.83398 31.667 4.25065 31.667 7.08398V26.9173C31.667 29.7507 30.2503 31.1673 27.417 31.1673H18.917C16.0837 31.1673 14.667 29.7507 14.667 26.9173Z"
        stroke="#00B7AC"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SearchIcon(props) {
  return (
    <svg
      className={props?.className ? props.className : ""}
      width={props?.width ? props.width : "31"}
      height={props?.height ? props.height : "30"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58366 17.4993C13.9559 17.4993 17.5003 13.9549 17.5003 9.58268C17.5003 5.21043 13.9559 1.66602 9.58366 1.66602C5.2114 1.66602 1.66699 5.21043 1.66699 9.58268C1.66699 13.9549 5.2114 17.4993 9.58366 17.4993Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3337 18.3327L16.667 16.666"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StarIcon(props) {
  return (
    <svg
      width={props?.width ? props.width : "16"}
      height={props?.height ? props.height : "14"}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.26355 0.279499C7.29744 0.196834 7.35515 0.126117 7.42935 0.0763466C7.50354 0.0265758 7.59086 0 7.68021 0C7.76955 0 7.85687 0.0265758 7.93107 0.0763466C8.00526 0.126117 8.06297 0.196834 8.09686 0.279499L9.79954 4.37474C9.83141 4.45136 9.8838 4.51772 9.95095 4.56649C10.0181 4.61526 10.0974 4.64456 10.1801 4.65117L14.6015 5.00533C15.0013 5.03738 15.1632 5.53656 14.8587 5.79697L11.4902 8.68311C11.4273 8.73695 11.3804 8.80707 11.3546 8.88579C11.3289 8.96452 11.3254 9.0488 11.3444 9.12941L12.374 13.4442C12.3947 13.5308 12.3893 13.6215 12.3584 13.705C12.3275 13.7885 12.2726 13.861 12.2006 13.9133C12.1286 13.9656 12.0427 13.9953 11.9538 13.9988C11.8648 14.0024 11.7768 13.9794 11.7009 13.933L7.91498 11.6213C7.84425 11.5782 7.76303 11.5554 7.68021 11.5554C7.59738 11.5554 7.51616 11.5782 7.44544 11.6213L3.65949 13.9338C3.58357 13.9802 3.49559 14.0032 3.40665 13.9997C3.31772 13.9961 3.23181 13.9664 3.15979 13.9141C3.08778 13.8618 3.03287 13.7893 3.00201 13.7058C2.97116 13.6223 2.96573 13.5316 2.98643 13.445L4.01605 9.12941C4.03514 9.0488 4.03163 8.96449 4.0059 8.88575C3.98017 8.80701 3.93322 8.73689 3.87022 8.68311L0.501722 5.79697C0.434267 5.73897 0.385467 5.66232 0.361461 5.57665C0.337455 5.49099 0.339313 5.40014 0.366803 5.31553C0.394292 5.23092 0.446186 5.15633 0.515957 5.10113C0.585728 5.04594 0.670261 5.01261 0.758927 5.00533L5.18028 4.65117C5.26301 4.64456 5.34231 4.61526 5.40946 4.56649C5.47661 4.51772 5.529 4.45136 5.56087 4.37474L7.26355 0.279499Z"
        fill={props?.fill ? props.fill : "#F5B950"}
      />
    </svg>
  );
}

export function TaskSquare() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3711 8.87988H17.6211"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.37891 8.87988L7.12891 9.62988L9.37891 7.37988"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3711 15.8799H17.6211"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.37891 15.8799L7.12891 16.6299L9.37891 14.3799"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function TwitterIcon(props) {
  return (
    <svg
      width={props?.width ? props.width : "31"}
      height={props?.height ? props.height : "30"}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15.5" cy="15" r="15" fill="#50A4CE" />
      <path
        d="M21.3583 11.4643C21.1345 11.5545 20.905 11.6275 20.6716 11.6828C20.6493 11.6882 20.6259 11.6855 20.6051 11.6752C20.5842 11.6648 20.5672 11.6473 20.5565 11.6254C20.5457 11.6035 20.542 11.5784 20.5458 11.554C20.5496 11.5296 20.5607 11.5072 20.5774 11.4903C20.845 11.2133 21.0655 10.8877 21.2288 10.5283C21.2382 10.507 21.2413 10.4831 21.2375 10.4599C21.2337 10.4367 21.2233 10.4153 21.2077 10.3989C21.1921 10.3824 21.1721 10.3716 21.1505 10.368C21.129 10.3644 21.1069 10.3682 21.0874 10.3789C20.6637 10.6245 20.2015 10.783 19.7243 10.8462C19.2241 10.3097 18.5495 10.006 17.8447 10C17.5052 9.99967 17.169 10.0717 16.8554 10.2119C16.5417 10.3521 16.2567 10.5578 16.0167 10.8171C15.7766 11.0765 15.5863 11.3845 15.4565 11.7234C15.3268 12.0623 15.2601 12.4256 15.2604 12.7924C15.2595 12.9986 15.2792 13.2043 15.3191 13.406C13.4295 13.3441 11.2236 12.3573 9.93485 10.6418C9.92411 10.6272 9.9102 10.6158 9.89436 10.6085C9.87852 10.6011 9.86126 10.5982 9.84409 10.5998C9.82693 10.6014 9.81041 10.6076 9.796 10.6178C9.78159 10.628 9.76974 10.6419 9.76151 10.6583C9.51316 11.2111 9.43906 11.8366 9.55053 12.4393C9.662 13.0419 9.95291 13.5886 10.3789 13.9959C10.396 14.0109 10.4082 14.0314 10.4139 14.0545C10.4195 14.0775 10.4183 14.1019 10.4103 14.1242C10.4023 14.1464 10.388 14.1653 10.3695 14.1782C10.3509 14.1912 10.3291 14.1974 10.307 14.196C10.0819 14.1852 9.86142 14.1237 9.6596 14.0155C9.64319 14.0065 9.62487 14.0024 9.60651 14.0035C9.58814 14.0046 9.57038 14.011 9.55501 14.0219C9.53964 14.0328 9.52722 14.0479 9.519 14.0657C9.51077 14.0835 9.50704 14.1033 9.50818 14.1231C9.52917 14.6564 9.69983 15.1701 9.99747 15.596C10.2951 16.022 10.7057 16.3399 11.1746 16.5077C11.1963 16.5162 11.2149 16.5323 11.2273 16.5534C11.2397 16.5745 11.2453 16.5995 11.2431 16.6244C11.241 16.6493 11.2312 16.6727 11.2154 16.691C11.1996 16.7092 11.1786 16.7213 11.1558 16.7253C10.9591 16.7494 10.7606 16.7494 10.5639 16.7253C10.5469 16.7236 10.5298 16.7263 10.514 16.7333C10.4982 16.7402 10.4843 16.7512 10.4733 16.7653C10.4623 16.7794 10.4546 16.7961 10.4509 16.8141C10.4472 16.8321 10.4475 16.8508 10.452 16.8686C10.6293 17.6092 11.5154 18.4764 12.5068 18.5954C12.5267 18.5982 12.5454 18.6071 12.5607 18.621C12.576 18.635 12.5872 18.6535 12.5931 18.6741C12.599 18.6948 12.5992 18.7169 12.5938 18.7378C12.5884 18.7586 12.5775 18.7773 12.5626 18.7917C11.7358 19.5072 10.6969 19.8742 9.63871 19.8246C9.615 19.8234 9.59164 19.8311 9.57247 19.8462C9.55331 19.8613 9.53948 19.883 9.53328 19.9078C9.52708 19.9326 9.52887 19.9589 9.53835 19.9824C9.54784 20.0059 9.56445 20.0252 9.58546 20.0371C10.702 20.6699 11.944 21.0002 13.2048 20.9998C14.1845 21.0068 15.1553 20.7978 16.0578 20.3856C16.9603 19.9734 17.7755 19.3666 18.4535 18.6024C19.1316 17.8381 19.6583 16.9325 20.0014 15.9408C20.3445 14.9491 20.4968 13.8923 20.449 12.8348V12.729C20.8457 12.4286 21.1938 12.0597 21.4794 11.637C21.4929 11.6174 21.5001 11.5936 21.5 11.5692C21.4999 11.5447 21.4924 11.521 21.4788 11.5016C21.4651 11.4821 21.446 11.468 21.4243 11.4613C21.4026 11.4545 21.3794 11.4556 21.3583 11.4643Z"
        fill="#FEFEFF"
      />
    </svg>
  );
}

export function YoutubeIcon(props) {
  return (
    <svg
      width={props?.width ? props.width : "31"}
      height={props?.height ? props.height : "30"}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15.5" cy="15" r="15" fill="#CC3300" />
      <path
        d="M18.5 20.6667H11.8333C9.83333 20.6667 8.5 19.3333 8.5 17.3333V13.3333C8.5 11.3333 9.83333 10 11.8333 10H18.5C20.5 10 21.8333 11.3333 21.8333 13.3333V17.3333C21.8333 19.3333 20.5 20.6667 18.5 20.6667Z"
        fill="#FEFEFF"
      />
      <path
        d="M15.1004 13.3332L16.7671 14.3332C17.3671 14.7332 17.3671 15.3332 16.7671 15.7332L15.1004 16.7332C14.4337 17.1332 13.9004 16.7999 13.9004 16.0665V14.0665C13.9004 13.1999 14.4337 12.9332 15.1004 13.3332Z"
        stroke="#23446B"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ProfileIcon(props) {
  return (
    <svg
      style={{ width: props.size, height: props.size }}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6334 9.05964C10.55 9.0513 10.45 9.0513 10.3584 9.05964C8.37505 8.99297 6.80005 7.36797 6.80005 5.36797C6.80005 3.3263 8.45005 1.66797 10.5 1.66797C12.5417 1.66797 14.2 3.3263 14.2 5.36797C14.1917 7.36797 12.6167 8.99297 10.6334 9.05964Z"
        stroke={props.color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.46672 12.132C4.45006 13.482 4.45006 15.682 6.46672 17.0237C8.75839 18.557 12.5167 18.557 14.8084 17.0237C16.8251 15.6737 16.8251 13.4737 14.8084 12.132C12.5251 10.607 8.76672 10.607 6.46672 12.132Z"
        stroke={props.color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SmsIcon(props) {
  return (
    <svg
      style={{ width: props.size, height: props.size }}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 17.0846H6.33329C3.83329 17.0846 2.16663 15.8346 2.16663 12.918V7.08464C2.16663 4.16797 3.83329 2.91797 6.33329 2.91797H14.6666C17.1666 2.91797 18.8333 4.16797 18.8333 7.08464V12.918C18.8333 15.8346 17.1666 17.0846 14.6666 17.0846Z"
        stroke={props.color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6667 7.5L12.0584 9.58333C11.2 10.2667 9.7917 10.2667 8.93337 9.58333L6.33337 7.5"
        stroke={props.color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function MobileIcon(props) {
  return (
    <svg
      style={{ width: props.size, height: props.size }}
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="vuesax/linear/mobile">
        <g id="mobile">
          <path
            id="Vector"
            d="M17 6.14844V16.1484C17 20.1484 16 21.1484 12 21.1484H6C2 21.1484 1 20.1484 1 16.1484V6.14844C1 2.14844 2 1.14844 6 1.14844H12C16 1.14844 17 2.14844 17 6.14844Z"
            stroke={props.color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M11 4.64844H7"
            stroke={props.color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_3"
            d="M9.0002 18.2484C9.85624 18.2484 10.5502 17.5545 10.5502 16.6984C10.5502 15.8424 9.85624 15.1484 9.0002 15.1484C8.14415 15.1484 7.4502 15.8424 7.4502 16.6984C7.4502 17.5545 8.14415 18.2484 9.0002 18.2484Z"
            stroke={props.color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}

export function Profile2Users(props) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.88411 9.05866C7.80078 9.05033 7.70078 9.05033 7.60911 9.05866C5.62578 8.99199 4.05078 7.36699 4.05078 5.36699C4.05078 3.32533 5.70078 1.66699 7.75078 1.66699C9.79245 1.66699 11.4508 3.32533 11.4508 5.36699C11.4424 7.36699 9.86745 8.99199 7.88411 9.05866Z"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.9247 3.33301C15.5414 3.33301 16.8414 4.64134 16.8414 6.24967C16.8414 7.82468 15.5914 9.10801 14.0331 9.16634C13.9664 9.15801 13.8914 9.15801 13.8164 9.16634"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.71758 12.133C1.70091 13.483 1.70091 15.683 3.71758 17.0247C6.00924 18.558 9.76758 18.558 12.0592 17.0247C14.0759 15.6747 14.0759 13.4747 12.0592 12.133C9.77591 10.608 6.01758 10.608 3.71758 12.133Z"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.5332 16.667C16.1332 16.542 16.6999 16.3003 17.1665 15.942C18.4665 14.967 18.4665 13.3587 17.1665 12.3837C16.7082 12.0337 16.1499 11.8003 15.5582 11.667"
        stroke="#707170"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function WifiIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9.96004C9.63 7.15004 14.37 7.15004 18 9.96004"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.59961 13.0499C10.2696 10.9899 13.7396 10.9899 16.4096 13.0499"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.7998 16.1402C11.1298 15.1102 12.8698 15.1102 14.1998 16.1402"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CoffeeIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.79 10.4698V17.7898C17.79 20.1198 15.9 21.9998 13.58 21.9998H6.21C3.89 21.9998 2 20.1098 2 17.7898V10.4698C2 8.13977 3.89 6.25977 6.21 6.25977H13.58C15.9 6.25977 17.79 8.14977 17.79 10.4698Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 4V2.25"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5 4V2.25"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 4V2.25"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 13.1602C22 15.4802 20.11 17.3702 17.79 17.3702V8.9502C20.11 8.9502 22 10.8302 22 13.1602Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 12H17.51"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className="mx-2 mt-1"
    >
      <path
        d="M14.43 6.01953L20.5 12.0895L14.43 18.1595M3.5 12.0895H20.33"
        stroke="rgba(var(--web-page-primary-color))"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CameraIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_30591_39291"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="30"
        height="30"
      >
        <path
          d="M29.9165 29.917V2.08375H2.08325V29.917H29.9165Z"
          fill="white"
          stroke="white"
          stroke-width="1.5"
        />
      </mask>
      <g mask="url(#mask0_30591_39291)">
        <path
          d="M20.5273 9.55703H4.49391C3.22834 9.55703 2.19263 10.5926 2.19263 11.8582V27.5064C2.19263 28.7721 3.22834 29.8076 4.49391 29.8076H27.5057C28.7713 29.8076 29.8071 28.7721 29.8071 27.5064V11.8582C29.8071 10.5925 28.7713 9.55703 27.5057 9.55703H26.8632"
          stroke="#1E85FF"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.6967 3.81911L20.6408 2.19323L20.5208 5.65261L17.585 7.48605L20.5208 9.31949L20.6408 12.7788L23.6967 11.153L26.7524 12.7788L26.8725 9.31949L29.8083 7.48605L26.8725 5.65261L26.7524 2.19323L23.6967 3.81911Z"
          stroke="#1E85FF"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.55469 20.6029C9.55469 24.1615 12.4395 27.0464 15.9981 27.0464C19.5569 27.0464 22.4415 24.1615 22.4415 20.6029C22.4415 17.0444 19.5569 14.1596 15.9981 14.1596C12.4395 14.1596 9.55469 17.0444 9.55469 20.6029Z"
          stroke="#1E85FF"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.3188 20.6031C12.3188 22.6366 13.9672 24.2852 16.0007 24.2852C18.0342 24.2852 19.6827 22.6366 19.6827 20.6031C19.6827 18.5696 18.0342 16.9213 16.0007 16.9213C13.9672 16.9213 12.3188 18.5696 12.3188 20.6031Z"
          stroke="#1E85FF"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.3964 9.55762H5.87354V6.79611H11.3964V9.55762Z"
          stroke="#1E85FF"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.71354 13.6993C7.71354 14.4618 7.09531 15.0801 6.33282 15.0801C5.57038 15.0801 4.95215 14.4618 4.95215 13.6993C4.95215 12.9367 5.57038 12.3186 6.33282 12.3186C7.09531 12.3186 7.71354 12.9367 7.71354 13.6993Z"
          stroke="#1E85FF"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
}

export function BusIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9 22H7.10001C5.40001 22 4 20.61 4 18.9V5.10001C4 3.40001 5.39001 2 7.10001 2H16.9C18.6 2 20 3.39001 20 5.10001V18.9C20 20.61 18.61 22 16.9 22Z"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5 13H5.5C4.67 13 4 12.33 4 11.5V9.5C4 8.67 4.67 8 5.5 8H18.5C19.33 8 20 8.67 20 9.5V11.5C20 12.33 19.33 13 18.5 13Z"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.49451 17.7002H8.50349"
        stroke="#889DAD"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.4945 17.7002H15.5035"
        stroke="#889DAD"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5 5H14.5"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function PeopleIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 7.16C17.94 7.15 17.87 7.15 17.81 7.16C16.43 7.11 15.33 5.98 15.33 4.58C15.33 3.15 16.48 2 17.91 2C19.34 2 20.49 3.16 20.49 4.58C20.48 5.98 19.38 7.11 18 7.16Z"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.9699 14.4402C18.3399 14.6702 19.8499 14.4302 20.9099 13.7202C22.3199 12.7802 22.3199 11.2402 20.9099 10.3002C19.8399 9.59016 18.3099 9.35016 16.9399 9.59016"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.96998 7.16C6.02998 7.15 6.09998 7.15 6.15998 7.16C7.53998 7.11 8.63998 5.98 8.63998 4.58C8.63998 3.15 7.48998 2 6.05998 2C4.62998 2 3.47998 3.16 3.47998 4.58C3.48998 5.98 4.58998 7.11 5.96998 7.16Z"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.99994 14.4402C5.62994 14.6702 4.11994 14.4302 3.05994 13.7202C1.64994 12.7802 1.64994 11.2402 3.05994 10.3002C4.12994 9.59016 5.65994 9.35016 7.02994 9.59016"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 14.6302C11.94 14.6202 11.87 14.6202 11.81 14.6302C10.43 14.5802 9.32996 13.4502 9.32996 12.0502C9.32996 10.6202 10.48 9.47021 11.91 9.47021C13.34 9.47021 14.49 10.6302 14.49 12.0502C14.48 13.4502 13.38 14.5902 12 14.6302Z"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.08997 17.7804C7.67997 18.7204 7.67997 20.2603 9.08997 21.2003C10.69 22.2703 13.31 22.2703 14.91 21.2003C16.32 20.2603 16.32 18.7204 14.91 17.7804C13.32 16.7204 10.69 16.7204 9.08997 17.7804Z"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function RoutingIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.07006 4.59988C2.87006 1.13988 8.08006 1.13988 8.87006 4.59988C9.34006 6.62988 8.05006 8.34988 6.93006 9.41988C6.11006 10.1999 4.82006 10.1899 4.00006 9.41988C2.89006 8.34988 1.60006 6.62988 2.07006 4.59988Z"
        stroke="#889DAD"
        stroke-width="1.5"
      />
      <path
        d="M15.07 16.5999C15.87 13.1399 21.11 13.1399 21.91 16.5999C22.38 18.6299 21.09 20.3499 19.96 21.4199C19.14 22.1999 17.84 22.1899 17.02 21.4199C15.89 20.3499 14.6 18.6299 15.07 16.5999Z"
        stroke="#889DAD"
        stroke-width="1.5"
      />
      <path
        d="M11.9999 5H14.6799C16.5299 5 17.3899 7.29 15.9999 8.51L8.00995 15.5C6.61995 16.71 7.47994 19 9.31994 19H11.9999"
        stroke="#889DAD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.48622 5.5H5.49777"
        stroke="#889DAD"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.4862 17.5H18.4978"
        stroke="#889DAD"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function GlobalIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z"
        stroke="#AEBBC5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99998 3.5H8.99998C7.04998 9.34 7.04998 15.66 8.99998 21.5H7.99998"
        stroke="#AEBBC5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 3.5C16.95 9.34 16.95 15.66 15 21.5"
        stroke="#AEBBC5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 16.5V15.5C8.84 17.45 15.16 17.45 21 15.5V16.5"
        stroke="#AEBBC5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 9.5001C8.84 7.5501 15.16 7.5501 21 9.5001"
        stroke="#AEBBC5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function VerticleAirPlanPath() {
  return (
    <svg
      width="6"
      height="86"
      viewBox="0 0 6 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 85.1667C4.47276 85.1667 5.66667 83.9728 5.66667 82.5C5.66667 81.0272 4.47276 79.8333 3 79.8333C1.52724 79.8333 0.333333 81.0272 0.333333 82.5C0.333333 83.9728 1.52724 85.1667 3 85.1667ZM3 6.16666C4.47276 6.16666 5.66667 4.97276 5.66667 3.5C5.66667 2.02724 4.47276 0.833328 3 0.833328C1.52724 0.833328 0.333337 2.02724 0.333337 3.5C0.333337 4.97276 1.52724 6.16666 3 6.16666ZM3.5 82.5L3.5 81.5125L2.5 81.5125L2.5 82.5L3.5 82.5ZM3.5 79.5375L3.5 77.5625L2.5 77.5625L2.5 79.5375L3.5 79.5375ZM3.5 75.5875L3.5 73.6125L2.5 73.6125L2.5 75.5875L3.5 75.5875ZM3.5 71.6375L3.5 69.6625L2.5 69.6625L2.5 71.6375L3.5 71.6375ZM3.5 67.6875L3.5 65.7125L2.5 65.7125L2.5 67.6875L3.5 67.6875ZM3.5 63.7375L3.5 61.7625L2.5 61.7625L2.5 63.7375L3.5 63.7375ZM3.5 59.7875L3.5 57.8125L2.5 57.8125L2.5 59.7875L3.5 59.7875ZM3.5 55.8375L3.5 53.8625L2.5 53.8625L2.5 55.8375L3.5 55.8375ZM3.5 51.8875L3.5 49.9125L2.5 49.9125L2.5 51.8875L3.5 51.8875ZM3.5 47.9375L3.5 45.9625L2.5 45.9625L2.5 47.9375L3.5 47.9375ZM3.5 43.9875L3.5 42.0125L2.5 42.0125L2.5 43.9875L3.5 43.9875ZM3.5 40.0375L3.5 38.0625L2.5 38.0625L2.5 40.0375L3.5 40.0375ZM3.5 36.0875L3.5 34.1125L2.5 34.1125L2.5 36.0875L3.5 36.0875ZM3.5 32.1375L3.5 30.1625L2.5 30.1625L2.5 32.1375L3.5 32.1375ZM3.5 28.1875L3.5 26.2125L2.5 26.2125L2.5 28.1875L3.5 28.1875ZM3.5 24.2375L3.5 22.2625L2.5 22.2625L2.5 24.2375L3.5 24.2375ZM3.5 20.2875L3.5 18.3125L2.5 18.3125L2.5 20.2875L3.5 20.2875ZM3.5 16.3375L3.5 14.3625L2.5 14.3625L2.5 16.3375L3.5 16.3375ZM3.5 12.3875L3.5 10.4125L2.5 10.4125L2.5 12.3875L3.5 12.3875ZM3.5 8.43752L3.5 6.46252L2.5 6.46252L2.5 8.43752L3.5 8.43752ZM3.5 4.48753L3.5 3.5L2.5 3.5L2.5 4.48753L3.5 4.48753Z"
        fill="#1E85FF"
      />
    </svg>
  );
}

export function CaretTopIcon() {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 5.5L5 1.5L9 5.5"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
